export enum VideoProvider {
  Recruitee = 'recruitee',
  Google = 'google',
  Zoom = 'zoom',
  Teams = 'teams',
  Jitsi = 'jitsi',
}

export enum InterviewKind {
  Video = 'video',
  Call = 'call',
  Onsite = 'onsite',
  Meeting = 'meeting',
}
